import { LineChart } from "@mui/x-charts";
import { normalSanatizerBRL } from "src/utils/functions";
import { Vis_PraResult } from "../Vista-Prazo";

export const VistaPrazoGraph = ({ results }: { results: Vis_PraResult }) => {
  const meses = results.fluxoMensal.map((f) => f.mes);
  const valoresPrazo = results.fluxoMensal.map((f) => f.valorParaInvestir);
  const valorsemInvestir = results.fluxoSemInvestir.map(
    (f) => f.valorSemInvestir,
  );
  let resultInvestindo = valoresPrazo[valoresPrazo.length - 1];
  let ultimoObjeto = valorsemInvestir[valorsemInvestir.length - 1];
  ultimoObjeto = Math.abs(ultimoObjeto);

  return (
    <>
      <div className="flex flex-col md:flex-row md:justify-center gap-4 md:gap-10 mx-4 md:mx-10">
        <div className="p-3 bg-white rounded-md border flex flex-col w-full md:w-[47%] justify-center ">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Rendimento investido
          </h2>
          <p className="sm:text-lg text-center font-black text-2xl text-black m-0">
            <span className="text-sm mr-1 text-gray-500">R$</span>
            {normalSanatizerBRL(resultInvestindo)}
          </p>
        </div>
        <div className="p-3 bg-white rounded-md border flex flex-col w-full md:w-[47%] justify-center ">
          <h2 className="sm:text-base text-sm text-center font-semibold m-0">
            Rendimento sem investir
          </h2>
          <p className="sm:text-lg text-center font-black text-2xl text-black m-0">
            <span className="text-sm mr-1 text-red-600">- R$</span>
            <span className="text-red-600">
              {normalSanatizerBRL(ultimoObjeto)}
            </span>
          </p>
        </div>
      </div>
      <h2 className="font-bold text-primary text-lg mt-8 text-center">
        Gráfico
      </h2>
      <div className="w-full min-w-[300px] min-h-[300px] h-[300px] sm:h-[400px] md:h-[600px] overflow-auto -ml-2 sm:ml-0">
        <LineChart
          colors={["#8d0202", "#000"]}
          grid={{ vertical: false, horizontal: true }}
          xAxis={[
            {
              data: meses,
              label: "Mes",
              tickNumber: meses.length,
            },
          ]}
          series={[
            {
              data: valoresPrazo,
              label: "Investindo",
            },
            {
              data: valorsemInvestir,
              label: "Sem Investir",
            },
          ]}
        />
      </div>
      <div className="p-3 bg-white rounded border flex flex-col justify-center">
        <h2 className="sm:text-base text-black text-base text-center font-semibold m-0">
          Ao final de {results.numeroParcela} meses sem investir, seus{" "}
          <span className="text-red-600">R$ {results.restoInvestir}</span>{" "}
          valerão
          <span className="text-red-600">
            {" "}
            R$ {results.restoInvestir - Math.round(ultimoObjeto * 100) / 100}
          </span>{" "}
          em poder de compra, perdendo{" "}
          <span className="text-red-600">
            {" "}
            - R$ {Math.round(ultimoObjeto * 100) / 100}
          </span>{" "}
          devido à inflação.
        </h2>
        <p className="sm:text-xl text-center py-5 font-bold text-3xl text-red-600 m-0">
          - R$ {Math.round(ultimoObjeto * 100) / 100}
        </p>
      </div>
    </>
  );
};
